import React from "react";
import { AlertOctagon, CalendarClock } from "lucide-react";
import { formatDate } from "../lib/constants";

export const OnHoldBanner = ({ reason, date, expectedResumeDate }) => (
  <div
    className="rounded-[2px] px-6 py-4 flex items-start gap-4 border-l-[3px]"
    style={{
      backgroundColor: "var(--st-on-hold-bg)",
      borderLeftColor: "var(--st-on-hold-fg)",
      borderTop: "1px solid var(--st-on-hold-bd)",
      borderRight: "1px solid var(--st-on-hold-bd)",
      borderBottom: "1px solid var(--st-on-hold-bd)",
    }}
    data-testid="on-hold-banner"
  >
    <AlertOctagon
      className="mt-0.5 shrink-0"
      style={{ color: "var(--st-on-hold-fg)" }}
      size={20}
    />
    <div className="flex-1">
      <div className="label" style={{ color: "var(--st-on-hold-fg)" }}>
        Project on hold
      </div>
      <div className="mt-1 text-sm text-[color:var(--atech-text)]">
        {reason || "This project is currently paused."}
      </div>
      <div className="mt-1.5 flex flex-wrap items-center gap-x-3 gap-y-0.5 text-xs text-[color:var(--atech-text-muted)]">
        {date && <span>On hold since {formatDate(date)}</span>}
        {date && expectedResumeDate && <span className="opacity-30">·</span>}
        {expectedResumeDate && (
          <span
            className="flex items-center gap-1 text-[color:var(--atech-text-dim)]"
            data-testid="resume-date-label"
          >
            <CalendarClock size={12} />
            Expected to resume {formatDate(expectedResumeDate)}
          </span>
        )}
      </div>
    </div>
  </div>
);

export default OnHoldBanner;
